import * as yup from 'yup';
import { maxLengthFieldMessage } from './contact-us-schema';

const requiredFieldMessage = (fieldName: string): string => `${fieldName} is required`;

const max_characters = {
  firstName: 50,
  lastName: 50,
  email: 100,
};

export const titleMonitoringSignupSchema = (): any => {
  return yup.object().shape({
    firstName: yup
      .string()
      .required(requiredFieldMessage('First Name'))
      .max(max_characters.firstName, maxLengthFieldMessage(max_characters.firstName)),
    lastName: yup
      .string()
      .required(requiredFieldMessage('Last Name'))
      .max(max_characters.lastName, maxLengthFieldMessage(max_characters.lastName)),
    email: yup
      .string()
      .required(requiredFieldMessage('Email'))
      .email('Invalid Email, @ and . characters required.')
      .max(max_characters.email, maxLengthFieldMessage(max_characters.email)),
    phone: yup.string().test('is-10-digits', 'Incomplete Phone Number.', (value) => {
      if (!value || value.trim() === '') {
        return true;
      }
      return /^\d{3}-\d{3}-\d{4}$/.test(value) || /^\d{10}$/.test(value);
    }),
  });
};

export const titleMonitoringPropertyAddressSchema = yup.object().shape({
  address1: yup.string().max(55, 'Maximum of 55 characters').required(requiredFieldMessage('Address 1')),
  address2: yup.string().optional().max(55, 'Maximum of 55 characters'),
  city: yup.string().max(50, 'Maximum of 50 characters').required(requiredFieldMessage('City')),
  stateOrProvince: yup.string().required(requiredFieldMessage('State')),
  postalCode: yup
    .string()
    .matches(/(^$|^\b\d{5}(-\d{4})?\b$)/, 'Invalid zip code, 5 or 9 characters required.')
    .required(requiredFieldMessage('Zip')),
});
